import React from 'react';
import {IProduct} from 'data/interfaces/products';
import FlightDetailsCard from './components/flightDetailsCard';
import FlightSellerComments from './components/flightSellerComments';


interface IFirstPageProps {
  product?: IProduct;
}

const FirstStage = (props: IFirstPageProps) => (
  <>
    <FlightDetailsCard product={props.product}/>
    <FlightSellerComments product={props.product}/>
  </>
);

FirstStage.defaultProps = {};

export default React.memo(FirstStage);
